import React, { useEffect } from "react";
import AmenitiesSection from "../components/Amenities/AmenitiesSection";
import AmenitiesSection2 from "../components/Amenities/AmenitiesSection2";
import { Banner } from "../components/common/Banner";
import { useAppDispatch, useAppSelector } from "../Hooks";
import { getAminityData } from "../features/Aminity";
import { Loader } from "../components/common/Loader";
import { useTranslation } from "react-i18next";


const Amenities: React.FC<{ banner_title: string }> = ({ banner_title }) => {
    const dispatch = useAppDispatch();
    const { aminities, more_aminities, aminityLoader, status } = useAppSelector((state) => state.aminity);


    useEffect(() => {
        dispatch(getAminityData());
    }, [dispatch, status])

    if (aminityLoader) {
        return <Loader />;
    }
    return (
        <>
            <Banner banner_title={banner_title} />
            <AmenitiesSection aminities={aminities} />
            <AmenitiesSection2 aminities={more_aminities} />
        </>
    )
}
export default Amenities;